module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "save-as-pdf"
    }
  }, [_c('HeadersDetalhesResumo', {
    attrs: {
      "apelido": _vm.imovel.apelido,
      "proprietario": _vm.imovel.proprietario,
      "tipo": _vm.imovel.tipo,
      "savoynet": _vm.imovel.savoynet
    }
  }), _vm._v(" "), (_vm.ilustrativas.length > 0) ? _c('slick', {
    ref: "slick",
    staticClass: "hide-pdf",
    attrs: {
      "options": _vm.slickOptions
    }
  }, _vm._l((_vm.ilustrativas), function(item, index) {
    return _c('img', {
      attrs: {
        "src": item.foto,
        "height": "350"
      }
    })
  })) : _vm._e(), _vm._v(" "), (_vm.showVistoriaColumn || _vm.$hasGranularPermission('tarefas', 'view')) ? [_c('v-subheader', [_vm._v("Vistoria e Tarefas")]), _vm._v(" "), _c('v-layout', {
    staticClass: "vistoria-tarefas-layout",
    attrs: {
      "row": ""
    }
  }, [(_vm.showVistoriaColumn) ? _c('v-flex', {
    staticClass: "px-5",
    attrs: {
      "xs12": "",
      "md6": ""
    }
  }, [(_vm.showVistoriaEmptyState) ? _c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-text', [_c('v-icon', {
    staticClass: "mr-2"
  }, [_vm._v("schedule")]), _vm._v(" "), _c('span', {
    staticClass: "subheading"
  }, [_vm._v("Sem vistoria agendada")])], 1), _vm._v(" "), (_vm.canAddVistoria) ? _c('v-card-text', {
    staticClass: "pt-0 pb-3"
  }, [_c('v-btn', {
    staticClass: "mx-0 secondary secondary--text",
    attrs: {
      "outline": "",
      "large": "",
      "to": ({
        name: 'VistoriaAdicionar',
        params: {
          id: _vm.$route.params.id
        }
      })
    }
  }, [_vm._v("Agendar vistoria")])], 1) : _vm._e()], 1) : (_vm.canShowVistoriaCard) ? _c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-text', [_c('div', [_c('span', [_c('v-icon', [_vm._v("schedule")]), _vm._v(" "), (_vm.vistoria.data_formatada) ? _c('VistoriaSituacao', {
    key: _vm.vistoria.data,
    staticClass: "mr-5",
    attrs: {
      "situacao": _vm.vistoria.situacao
    }
  }, [_vm._v(_vm._s(_vm.vistoria.data_formatada))]) : _vm._e()], 1), _vm._v(" "), _c('span', [_c('VistoriaSituacao', {
    key: _vm.vistoria.data,
    attrs: {
      "situacao": _vm.vistoria.situacao
    }
  })], 1), _vm._v(" "), (_vm.vistoria.recorrencia) ? _c('div', {
    staticClass: "mt-2"
  }, [_vm._v("\n              " + _vm._s(_vm.vistoria.recorrencia_formatada) + "\n            ")]) : _vm._e(), _vm._v(" "), _c('div', [_c('span', {
    staticClass: "grey--text"
  }, [_vm._v(_vm._s(_vm.vistoriaUserName()))])]), _vm._v(" "), (_vm.vistoria.observacoes) ? _c('div', {
    staticClass: "mt-3 mb-1"
  }, [_vm._v("\n              " + _vm._s(_vm.vistoria.observacoes) + "\n            ")]) : _vm._e()])]), _vm._v(" "), (_vm.canCompleteVistoria) ? _c('v-card-text', {
    staticClass: "pt-0 pb-3"
  }, [_c('VistoriaRealizar', {
    attrs: {
      "vistoriaId": _vm.vistoria.id,
      "imovelId": _vm.$route.params.id
    }
  })], 1) : _vm._e()], 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.showVistoriaColumn && _vm.$hasGranularPermission('tarefas', 'view')) ? _c('div', {
    staticClass: "borda_imoveis"
  }) : _vm._e(), _vm._v(" "), (_vm.$hasGranularPermission('tarefas', 'view')) ? _c('v-flex', {
    staticClass: "px-5",
    attrs: {
      "xs12": "",
      "md6": ""
    }
  }, [(_vm.tarefas.length < 1) ? _c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-text', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('div', [_c('v-icon', {
    staticClass: "mr-2"
  }, [_vm._v("event_available")]), _vm._v(" "), _c('span', {
    staticClass: "subheading"
  }, [_vm._v("Sem tarefas agendadas")])], 1)])], 1), _vm._v(" "), (_vm.canAddTask) ? _c('v-card-text', {
    staticClass: "pt-0 pb-3"
  }, [_c('v-btn', {
    staticClass: "mx-0 secondary secondary--text",
    attrs: {
      "outline": "",
      "large": "",
      "to": ({
        name: 'TarefasAdicionar',
        params: {
          id: _vm.$route.params.id
        }
      })
    }
  }, [_vm._v("Agendar tarefa")])], 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _vm._l((_vm.tarefas), function(item, index) {
    return _c('v-card', {
      key: item.id,
      attrs: {
        "flat": ""
      }
    }, [_c('v-card-text', [_c('div', [_c('span', [_c('v-icon', [_vm._v("event_available")]), _vm._v(" "), (item.data_formatada) ? _c('TarefasSituacao', {
      key: index,
      staticClass: "mr-5",
      attrs: {
        "data": item.data,
        "realizada": item.realizada
      }
    }, [_vm._v(_vm._s(item.data_formatada))]) : _vm._e()], 1), _vm._v(" "), _c('span', [_c('TarefasSituacao', {
      key: index,
      attrs: {
        "data": item.data,
        "realizada": item.realizada
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "mt-2"
    }, [_vm._v("\n              " + _vm._s(item.tipo) + "\n            ")]), _vm._v(" "), _c('div', [_c('span', {
      staticClass: "grey--text"
    }, [_vm._v(_vm._s(_vm.taskUserName(item)))])])])]), _vm._v(" "), (_vm.isTaskAssignedToCurrentUser(item)) ? _c('v-card-text', {
      staticClass: "pt-0 pb-3"
    }, [_c('TarefasRealizar', {
      attrs: {
        "tarefaId": item.id,
        "imovelId": _vm.$route.params.id
      }
    })], 1) : _vm._e(), _vm._v(" "), (_vm.tarefas.length > index + 1) ? _c('v-divider') : _vm._e()], 1)
  })], 2) : _vm._e()], 1)] : _vm._e(), _vm._v(" "), _c('v-subheader', [_vm._v("Cadastro")]), _vm._v(" "), (_vm.coords.lat !== null && _vm.coords.lng !== null && _vm.$hasGranularPermission('endereco', 'view')) ? _c('v-card', {
    staticClass: "hide-pdf",
    attrs: {
      "flat": ""
    }
  }, [(_vm.coords.lat !== null && _vm.coords.lng !== null) ? _c('gmap-map', {
    staticStyle: {
      "width": "100%",
      "height": "460px",
      "margin-bottom": "10px"
    },
    attrs: {
      "center": _vm.coords,
      "zoom": 15,
      "options": {
        clickableIcons: false,
        disableDoubleClickZoom: true,
        streetViewControl: false,
        mapTypeControl: true,
        zoomControl: false,
        fullscreenControl: false
      }
    }
  }, [_c('gmap-marker', {
    attrs: {
      "position": _vm.coords,
      "icon": _vm.getIcon(),
      "clickable": false
    }
  })], 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.$hasGranularPermission('endereco', 'view')) ? _c('v-card', {
    staticClass: "px-5",
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-text', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('div', [_c('v-icon', {
    staticClass: "mr-2"
  }, [_vm._v("room")])], 1), _vm._v(" "), (!_vm.imovel.hasOwnProperty('endereco')) ? [_c('strong', [_vm._v("Endereço")])] : [_c('v-flex', {
    staticClass: "pr-5",
    attrs: {
      "xs12": "",
      "md6": ""
    }
  }, [_c('p', [_c('strong', [_vm._v("Endereço")])]), _vm._v(" "), _vm._l((this.endereco), function(item, index) {
    return (index !== 'observacoes' && index !== 'anexos') ? _c('p', {
      key: index
    }, [_vm._v(_vm._s(item))]) : _vm._e()
  }), _vm._v(" "), (this.loteamento) ? _c('div', [_c('v-divider', {
    staticClass: "mt-1 mb-3"
  }), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Loteamento")])]), _vm._v(" "), _vm._l((this.loteamento), function(item) {
    return _c('p', {
      key: item.id
    }, [_vm._v(_vm._s(item))])
  })], 2) : _vm._e()], 2), _vm._v(" "), (this.endereco.observacoes.length > 0 || this.endereco.anexos.length > 0) ? _c('div', {
    staticClass: "borda_imoveis"
  }) : _vm._e(), _vm._v(" "), _c('v-flex', {
    staticClass: "pl-5",
    attrs: {
      "xs12": "",
      "md6": ""
    }
  }, [(this.endereco.observacoes.length > 0) ? _c('div', {
    staticClass: "mb-2"
  }, [_c('p', {
    staticClass: "mb-2"
  }, [_c('strong', [_vm._v("Observações")])]), _vm._v(" "), _vm._l((this.endereco.observacoes), function(item) {
    return _c('p', {
      key: item.id,
      staticClass: "mb-0"
    }, [_c('span', {
      staticClass: "data"
    }, [_vm._v(_vm._s(item.data) + ":")]), _vm._v(" " + _vm._s(item.conteudo))])
  })], 2) : _vm._e(), _vm._v(" "), (this.endereco.anexos.length > 0) ? _c('div', {
    staticClass: "hide-pdf"
  }, [_c('p', {
    staticClass: "mb-2"
  }, [_c('strong', [_vm._v("Anexos")])]), _vm._v(" "), _c('v-layout', {
    staticClass: "arquivos_mosaico text-xs-center",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, _vm._l((this.endereco.anexos), function(item) {
    return _c('v-flex', {
      key: item.id,
      staticClass: "mb-2",
      attrs: {
        "xs6": "",
        "sm3": "",
        "md2": ""
      }
    }, [_c('a', {
      attrs: {
        "href": item.path,
        "target": "_blank"
      }
    }, [_c('FileIcon', {
      attrs: {
        "filename": item.titulo,
        "large": ""
      }
    })], 1), _vm._v(" "), _c('div', [_vm._v(_vm._s((item.legenda ? item.legenda : item.titulo)))]), _vm._v(" "), _c('div', {
      staticClass: "data"
    }, [_vm._v(_vm._s(item.data))])])
  }))], 1) : _vm._e()])]], 2)], 1), _vm._v(" "), _c('v-divider')], 1) : _vm._e(), _vm._v(" "), (_vm.$hasGranularPermission('registro', 'view')) ? _c('v-card', {
    staticClass: "px-5",
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-text', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('div', [_c('v-icon', {
    staticClass: "mr-2"
  }, [_vm._v("description")])], 1), _vm._v(" "), (!_vm.imovel.hasOwnProperty('registro')) ? [_c('strong', [_vm._v("Registros / documentos")])] : [_c('v-flex', {
    staticClass: "pr-5",
    attrs: {
      "xs12": "",
      "md6": ""
    }
  }, [_c('p', [_c('strong', [_vm._v("Registros / documentos")])]), _vm._v(" "), _vm._l((this.registro), function(item, index) {
    return (index !== 'observacoes' && index !== 'anexos') ? _c('p', {
      key: index
    }, [_c('strong', [_vm._v(_vm._s(index) + ":")]), _vm._v(" " + _vm._s(item))]) : _vm._e()
  })], 2), _vm._v(" "), (this.registro.observacoes.length > 0 || this.registro.anexos.length > 0) ? _c('div', {
    staticClass: "borda_imoveis"
  }) : _vm._e(), _vm._v(" "), _c('v-flex', {
    staticClass: "pl-5",
    attrs: {
      "xs12": "",
      "md6": ""
    }
  }, [(this.registro.observacoes.length > 0) ? _c('div', {
    staticClass: "mb-2"
  }, [_c('p', {
    staticClass: "mb-2"
  }, [_c('strong', [_vm._v("Observações")])]), _vm._v(" "), _vm._l((this.registro.observacoes), function(item) {
    return _c('p', {
      key: item.id,
      staticClass: "mb-0"
    }, [_c('span', {
      staticClass: "data"
    }, [_vm._v(_vm._s(item.data) + ":")]), _vm._v(" " + _vm._s(item.conteudo))])
  })], 2) : _vm._e(), _vm._v(" "), (this.registro.anexos.length > 0) ? _c('div', {
    staticClass: "hide-pdf"
  }, [_c('p', {
    staticClass: "mb-2"
  }, [_c('strong', [_vm._v("Anexos")])]), _vm._v(" "), _c('v-layout', {
    staticClass: "arquivos_mosaico text-xs-center",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, _vm._l((this.registro.anexos), function(item) {
    return _c('v-flex', {
      key: item.id,
      staticClass: "mb-2",
      attrs: {
        "xs6": "",
        "sm3": "",
        "md2": ""
      }
    }, [_c('a', {
      attrs: {
        "href": item.path,
        "target": "_blank"
      }
    }, [_c('FileIcon', {
      attrs: {
        "filename": item.titulo,
        "large": ""
      }
    })], 1), _vm._v(" "), _c('div', [_vm._v(_vm._s((item.legenda ? item.legenda : item.titulo)))]), _vm._v(" "), _c('div', {
      staticClass: "data"
    }, [_vm._v(_vm._s(item.data))])])
  }))], 1) : _vm._e()])]], 2)], 1), _vm._v(" "), _c('v-divider')], 1) : _vm._e(), _vm._v(" "), (_vm.$hasGranularPermission('area', 'view')) ? _c('v-card', {
    staticClass: "px-5",
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-text', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('div', [_c('v-icon', {
    staticClass: "mr-2"
  }, [_vm._v("filter_hdr")])], 1), _vm._v(" "), (!_vm.imovel.hasOwnProperty('area')) ? [_c('strong', [_vm._v("Área")])] : [_c('v-flex', {
    staticClass: "pr-5",
    attrs: {
      "xs12": "",
      "md6": ""
    }
  }, [_c('p', [_c('strong', [_vm._v("Área")])]), _vm._v(" "), _vm._l((this.area), function(item, index) {
    return (item.length > 0 && index !== 'Calçada' && index !== 'Muro' && index !== 'observacoes' && index !== 'anexos') ? _c('p', {
      key: item.id
    }, [_c('strong', [_vm._v(_vm._s(index) + ":")]), _vm._v(" " + _vm._s(item) + "\n            ")]) : _vm._e()
  }), _vm._v(" "), _vm._l((this.area), function(item, index) {
    return (index === 'Calçada' || index === 'Muro') ? _c('p', {
      key: item.id
    }, [_vm._v("\n              " + _vm._s(item) + " " + _vm._s(index.toLowerCase()) + "\n            ")]) : _vm._e()
  })], 2), _vm._v(" "), (this.area.observacoes.length > 0 || this.area.anexos.length > 0) ? _c('div', {
    staticClass: "borda_imoveis"
  }) : _vm._e(), _vm._v(" "), _c('v-flex', {
    staticClass: "pl-5",
    attrs: {
      "xs12": "",
      "md6": ""
    }
  }, [(this.area.observacoes.length > 0) ? _c('div', {
    staticClass: "mb-2"
  }, [_c('p', {
    staticClass: "mb-2"
  }, [_c('strong', [_vm._v("Observações")])]), _vm._v(" "), _vm._l((this.area.observacoes), function(item) {
    return _c('p', {
      key: item.id,
      staticClass: "mb-0"
    }, [_c('span', {
      staticClass: "data"
    }, [_vm._v(_vm._s(item.data) + ":")]), _vm._v(" " + _vm._s(item.conteudo))])
  })], 2) : _vm._e(), _vm._v(" "), (this.area.anexos.length > 0) ? _c('div', {
    staticClass: "hide-pdf"
  }, [_c('p', {
    staticClass: "mb-2"
  }, [_c('strong', [_vm._v("Anexos")])]), _vm._v(" "), _c('v-layout', {
    staticClass: "arquivos_mosaico text-xs-center",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, _vm._l((this.area.anexos), function(item) {
    return _c('v-flex', {
      key: item.id,
      staticClass: "mb-2",
      attrs: {
        "xs6": "",
        "sm3": "",
        "md2": ""
      }
    }, [_c('a', {
      attrs: {
        "href": item.path,
        "target": "_blank"
      }
    }, [_c('FileIcon', {
      attrs: {
        "filename": item.titulo,
        "large": ""
      }
    })], 1), _vm._v(" "), _c('div', [_vm._v(_vm._s((item.legenda ? item.legenda : item.titulo)))]), _vm._v(" "), _c('div', {
      staticClass: "data"
    }, [_vm._v(_vm._s(item.data))])])
  }))], 1) : _vm._e()])]], 2)], 1), _vm._v(" "), _c('v-divider')], 1) : _vm._e(), _vm._v(" "), (_vm.$hasGranularPermission('taxas', 'view')) ? _c('v-card', {
    staticClass: "px-5",
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-text', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('div', [_c('v-icon', {
    staticClass: "mr-2"
  }, [_vm._v("location_city")])], 1), _vm._v(" "), (_vm.taxas.lista.length < 1) ? [_c('strong', [_vm._v("IPTU / impostos / taxas")])] : [_c('v-flex', {
    staticClass: "pr-5",
    attrs: {
      "xs12": "",
      "md6": ""
    }
  }, [_c('p', [_c('strong', [_vm._v("IPTU / impostos / taxas")])]), _vm._v(" "), _vm._l((_vm.taxas.lista), function(item, index) {
    return _c('div', {
      key: item.id
    }, [_c('p', [_c('strong', [_vm._v(_vm._s(item.taxa) + ":")]), _vm._v(" " + _vm._s(item.numero))]), _vm._v(" "), (item.situacao) ? _c('p', [_c('strong', [_vm._v("Situação:")]), _vm._v(" " + _vm._s(item.situacao))]) : _vm._e(), _vm._v(" "), (item.situacao === 'Pendente ajuizado' && item.ajuizado_cliente) ? _c('p', [_c('strong', [_vm._v("Cliente/caso:")]), _vm._v(" " + _vm._s(item.ajuizado_cliente))]) : _vm._e(), _vm._v(" "), (item.situacao === 'Pendente ajuizado' && item.ajuizado_processo) ? _c('p', [_c('strong', [_vm._v("Processo/execução:")]), _vm._v(" " + _vm._s(item.ajuizado_processo))]) : _vm._e(), _vm._v(" "), (index + 1 < _vm.taxas.lista.length) ? _c('v-divider', {
      key: item.id,
      staticClass: "mb-3"
    }) : _vm._e()], 1)
  })], 2), _vm._v(" "), (this.taxas.observacoes.length > 0 || this.taxas.anexos.length > 0) ? _c('div', {
    staticClass: "borda_imoveis"
  }) : _vm._e(), _vm._v(" "), _c('v-flex', {
    staticClass: "pl-5",
    attrs: {
      "xs12": "",
      "md6": ""
    }
  }, [(this.taxas.observacoes.length > 0) ? _c('div', {
    staticClass: "mb-2"
  }, [_c('p', {
    staticClass: "mb-2"
  }, [_c('strong', [_vm._v("Observações")])]), _vm._v(" "), _vm._l((this.taxas.observacoes), function(item) {
    return _c('p', {
      key: item.id,
      staticClass: "mb-0"
    }, [_c('span', {
      staticClass: "data"
    }, [_vm._v(_vm._s(item.data) + ":")]), _vm._v(" " + _vm._s(item.conteudo))])
  })], 2) : _vm._e(), _vm._v(" "), (this.taxas.anexos.length > 0) ? _c('div', {
    staticClass: "hide-pdf"
  }, [_c('p', {
    staticClass: "mb-2"
  }, [_c('strong', [_vm._v("Anexos")])]), _vm._v(" "), _c('v-layout', {
    staticClass: "arquivos_mosaico text-xs-center",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, _vm._l((this.taxas.anexos), function(item) {
    return _c('v-flex', {
      key: item.id,
      staticClass: "mb-2",
      attrs: {
        "xs6": "",
        "sm3": "",
        "md2": ""
      }
    }, [_c('a', {
      attrs: {
        "href": item.path,
        "target": "_blank"
      }
    }, [_c('FileIcon', {
      attrs: {
        "filename": item.titulo,
        "large": ""
      }
    })], 1), _vm._v(" "), _c('div', [_vm._v(_vm._s((item.legenda ? item.legenda : item.titulo)))]), _vm._v(" "), _c('div', {
      staticClass: "data"
    }, [_vm._v(_vm._s(item.data))])])
  }))], 1) : _vm._e()])]], 2)], 1), _vm._v(" "), _c('v-divider')], 1) : _vm._e(), _vm._v(" "), (_vm.$hasGranularPermission('valor', 'view')) ? _c('v-card', {
    staticClass: "px-5",
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-text', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('div', [_c('v-icon', {
    staticClass: "mr-2"
  }, [_vm._v("local_atm")])], 1), _vm._v(" "), (!_vm.imovel.hasOwnProperty('valor')) ? [_c('strong', [_vm._v("Valor")])] : [_c('v-flex', {
    staticClass: "pr-5",
    attrs: {
      "xs12": "",
      "md6": ""
    }
  }, [_c('p', [_c('strong', [_vm._v("Valor")])]), _vm._v(" "), _vm._l((this.valor), function(item, index) {
    return (item.length > 0 && index !== 'observacoes' && index !== 'anexos') ? _c('p', {
      key: item.id
    }, [_c('strong', [_vm._v(_vm._s(index) + ":")]), _vm._v(" " + _vm._s(item))]) : _vm._e()
  })], 2), _vm._v(" "), (this.valor.observacoes.length > 0 || this.valor.anexos.length > 0) ? _c('div', {
    staticClass: "borda_imoveis"
  }) : _vm._e(), _vm._v(" "), _c('v-flex', {
    staticClass: "pl-5",
    attrs: {
      "xs12": "",
      "md6": ""
    }
  }, [(this.valor.observacoes.length > 0) ? _c('div', {
    staticClass: "mb-2"
  }, [_c('p', {
    staticClass: "mb-2"
  }, [_c('strong', [_vm._v("Observações")])]), _vm._v(" "), _vm._l((this.valor.observacoes), function(item) {
    return _c('p', {
      key: item.id,
      staticClass: "mb-0"
    }, [_c('span', {
      staticClass: "data"
    }, [_vm._v(_vm._s(item.data) + ":")]), _vm._v(" " + _vm._s(item.conteudo))])
  })], 2) : _vm._e(), _vm._v(" "), (this.valor.anexos.length > 0) ? _c('div', {
    staticClass: "hide-pdf"
  }, [_c('p', {
    staticClass: "mb-2"
  }, [_c('strong', [_vm._v("Anexos")])]), _vm._v(" "), _c('v-layout', {
    staticClass: "arquivos_mosaico text-xs-center",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, _vm._l((this.valor.anexos), function(item) {
    return _c('v-flex', {
      key: item.id,
      staticClass: "mb-2",
      attrs: {
        "xs6": "",
        "sm3": "",
        "md2": ""
      }
    }, [_c('a', {
      attrs: {
        "href": item.path,
        "target": "_blank"
      }
    }, [_c('FileIcon', {
      attrs: {
        "filename": item.titulo,
        "large": ""
      }
    })], 1), _vm._v(" "), _c('div', [_vm._v(_vm._s((item.legenda ? item.legenda : item.titulo)))]), _vm._v(" "), _c('div', {
      staticClass: "data"
    }, [_vm._v(_vm._s(item.data))])])
  }))], 1) : _vm._e()])]], 2)], 1), _vm._v(" "), _c('v-divider')], 1) : _vm._e(), _vm._v(" "), (_vm.$hasGranularPermission('status', 'view')) ? _c('v-card', {
    staticClass: "px-5",
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-text', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('div', [_c('v-icon', {
    staticClass: "mr-2"
  }, [_vm._v("check_circle")])], 1), _vm._v(" "), (!_vm.imovel.hasOwnProperty('status')) ? [_c('strong', [_vm._v("Status")])] : [_c('v-flex', {
    staticClass: "pr-5",
    attrs: {
      "xs12": "",
      "md6": ""
    }
  }, [_c('p', [_c('strong', [_vm._v("Status")])]), _vm._v(" "), _c('p', {
    staticClass: "subheading"
  }, [_c('strong', [_vm._v(_vm._s(this.status.status))])]), _vm._v(" "), _vm._l((this.status), function(item, index) {
    return (item && index !== 'status' && index !== 'observacoes' && index !== 'anexos') ? [(/^divider.*/.test(index) === false && index !== 'Telefone') ? _c('p', {
      key: index
    }, [(index !== 'Placa' && index !== 'Condição' && index !== 'Índice') ? [_c('strong', [_vm._v(_vm._s(index) + ":")]), _vm._v(" " + _vm._s(item) + "\n                ")] : (index === 'Índice') ? [_c('strong', [_vm._v(_vm._s(index) + ":")]), _vm._v(" "), (typeof item === 'number') ? _c('span', {
      class: {
        'red--text': item < 1
      }
    }, [_vm._v(_vm._s(item) + "%")]) : _c('span', [_vm._v(_vm._s(item))])] : _c('strong', [_vm._v(_vm._s(item))])], 2) : (index === 'Telefone') ? _vm._l((item), function(telefone) {
      return _c('p', {
        key: item.id
      }, [_c('strong', {
        key: telefone.id
      }, [_vm._v(_vm._s(index) + ":")]), _vm._v(" " + _vm._s(telefone.numero) + "\n                ")])
    }) : _c('v-divider', {
      key: index,
      staticClass: "mt-1 mb-3"
    })] : _vm._e()
  })], 2), _vm._v(" "), (this.status.observacoes.length > 0 || this.status.anexos.length > 0) ? _c('div', {
    staticClass: "borda_imoveis"
  }) : _vm._e(), _vm._v(" "), _c('v-flex', {
    staticClass: "pl-5",
    attrs: {
      "xs12": "",
      "md6": ""
    }
  }, [(this.status.observacoes.length > 0) ? _c('div', {
    staticClass: "mb-2"
  }, [_c('p', {
    staticClass: "mb-2"
  }, [_c('strong', [_vm._v("Observações")])]), _vm._v(" "), _vm._l((this.status.observacoes), function(item) {
    return _c('p', {
      key: item.id,
      staticClass: "mb-0"
    }, [_c('span', {
      staticClass: "data"
    }, [_vm._v(_vm._s(item.data) + ":")]), _vm._v(" " + _vm._s(item.conteudo))])
  })], 2) : _vm._e(), _vm._v(" "), (this.status.anexos.length > 0) ? _c('div', {
    staticClass: "hide-pdf"
  }, [_c('p', {
    staticClass: "mb-2"
  }, [_c('strong', [_vm._v("Anexos")])]), _vm._v(" "), _c('v-layout', {
    staticClass: "arquivos_mosaico text-xs-center",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, _vm._l((this.status.anexos), function(item) {
    return _c('v-flex', {
      key: item.id,
      staticClass: "mb-2",
      attrs: {
        "xs6": "",
        "sm3": "",
        "md2": ""
      }
    }, [_c('a', {
      attrs: {
        "href": item.path,
        "target": "_blank"
      }
    }, [_c('FileIcon', {
      attrs: {
        "filename": item.titulo,
        "large": ""
      }
    })], 1), _vm._v(" "), _c('div', [_vm._v(_vm._s((item.legenda ? item.legenda : item.titulo)))]), _vm._v(" "), _c('div', {
      staticClass: "data"
    }, [_vm._v(_vm._s(item.data))])])
  }))], 1) : _vm._e()])]], 2)], 1), _vm._v(" "), _c('v-divider')], 1) : _vm._e(), _vm._v(" "), (_vm.$hasGranularPermission('observacoes', 'view')) ? [_c('v-card', {
    staticClass: "px-5",
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-text', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('div', [_c('v-icon', {
    staticClass: "mr-2"
  }, [_vm._v("assignment")])], 1), _vm._v(" "), _c('v-flex', [_c('strong', [_vm._v("Anotações")]), _vm._v(" "), (_vm.anotacoes.length > 0) ? _c('div', {
    staticClass: "mt-1"
  }, _vm._l((_vm.anotacoes), function(item) {
    return _c('p', {
      key: item.id,
      staticClass: "mb-0"
    }, [_c('span', {
      staticClass: "data"
    }, [_vm._v(_vm._s(item.data) + ":")]), _vm._v(" " + _vm._s(item.conteudo))])
  })) : _vm._e()])], 1)], 1), _vm._v(" "), (_vm.$hasGranularPermission('observacoes', 'view')) ? _c('div', {
    staticClass: "pt-0 pb-3 text-xs-center"
  }, [_c('v-btn', {
    staticClass: "secondary secondary--text",
    attrs: {
      "outline": "",
      "large": "",
      "to": ({
        name: 'ImoveisDetalhesObservacoes',
        params: {
          tipo: 'geral',
          id: _vm.$route.params.id
        }
      })
    }
  }, [_vm._v("Abrir anotações")])], 1) : _vm._e(), _vm._v(" "), _c('v-divider')], 1)] : _vm._e(), _vm._v(" "), (_vm.$hasGranularPermission('anexos', 'view')) ? [_c('v-card', {
    staticClass: "px-5 hide-pdf",
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-text', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('div', [_c('v-icon', {
    staticClass: "mr-2"
  }, [_vm._v("cloud_upload")])], 1), _vm._v(" "), _c('v-flex', [_c('strong', [_vm._v("Anexos")]), _vm._v(" "), _c('v-layout', {
    staticClass: "arquivos_mosaico text-xs-center",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, _vm._l((_vm.anexos), function(item) {
    return _c('v-flex', {
      key: item.id,
      staticClass: "mt-2 mb-1",
      attrs: {
        "xs6": "",
        "sm3": "",
        "md2": ""
      }
    }, [_c('a', {
      attrs: {
        "href": item.path,
        "target": "_blank"
      }
    }, [_c('FileIcon', {
      attrs: {
        "filename": item.titulo,
        "large": ""
      }
    })], 1), _vm._v(" "), _c('div', [_vm._v(_vm._s((item.legenda ? item.legenda : item.titulo)))]), _vm._v(" "), _c('div', {
      staticClass: "data"
    }, [_vm._v(_vm._s(item.data))])])
  }))], 1)], 1)], 1), _vm._v(" "), (_vm.$hasGranularPermission('anexos', 'view')) ? _c('div', {
    staticClass: "py-3 text-xs-center"
  }, [_c('v-btn', {
    staticClass: "secondary secondary--text",
    attrs: {
      "outline": "",
      "large": "",
      "to": ({
        name: 'ImoveisDetalhesAnexos',
        params: {
          tipo: 'geral',
          id: _vm.$route.params.id
        }
      })
    }
  }, [_vm._v("Abrir arquivos")])], 1) : _vm._e(), _vm._v(" "), _c('v-divider')], 1)] : _vm._e(), _vm._v(" "), (_vm.$hasGranularPermission('fotos', 'view')) ? [_c('v-card', {
    staticClass: "px-5 hide-pdf",
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-text', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('div', [_c('v-icon', {
    staticClass: "mr-2"
  }, [_vm._v("add_a_photo")])], 1), _vm._v(" "), _c('v-flex', [_c('strong', [_vm._v("Fotos")]), _vm._v(" "), _c('v-layout', {
    staticClass: "arquivos_mosaico text-xs-center",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, _vm._l((_vm.fotos), function(item) {
    return _c('v-flex', {
      key: item.id,
      staticClass: "mt-2 mb-1",
      attrs: {
        "xs6": "",
        "sm3": "",
        "md2": ""
      }
    }, [_c('FileIcon', {
      directives: [{
        name: "img",
        rawName: "v-img",
        value: ({
          src: item.foto,
          title: item.titulo
        }),
        expression: "{ src: item.foto, title: item.titulo }"
      }],
      attrs: {
        "filename": item.titulo,
        "large": ""
      }
    }), _vm._v(" "), _c('div', [_vm._v(_vm._s((item.legenda ? item.legenda : item.titulo)))]), _vm._v(" "), _c('div', {
      staticClass: "data"
    }, [_vm._v(_vm._s(item.data))])], 1)
  }))], 1)], 1)], 1), _vm._v(" "), (_vm.$hasGranularPermission('fotos', 'view')) ? _c('div', {
    staticClass: "py-3 text-xs-center"
  }, [_c('v-btn', {
    staticClass: "secondary secondary--text",
    attrs: {
      "outline": "",
      "large": "",
      "to": ({
        name: 'ImoveisDetalhesFotos',
        params: {
          tipo: 'geral',
          id: _vm.$route.params.id
        }
      })
    }
  }, [_vm._v("Abrir fotos")])], 1) : _vm._e(), _vm._v(" "), _c('v-divider')], 1)] : _vm._e(), _vm._v(" "), _c('IrParaOTopo'), _vm._v(" "), _c('DetalhesFAB', {
    attrs: {
      "status": _vm.status
    }
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-fa49ac24"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Imoveis/Detalhes/DetalhesResumo.vue
// module id = 1045
// module chunks = 1